import { useState } from "react";
import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar";
import { convertIdToText } from "../utils/utils";

export default function Home() {
    const [username, setUsername] = useState(localStorage.getItem("username"));
    const [email, setEmail] = useState(localStorage.getItem("email"));
    const [subscription, setSubscription] = useState(
        localStorage.getItem("subscription"),
    );

    return (
        <div>
            <Navbar />
            <div className="home-container">
                <h3>Account Info:</h3>
                <p>Email: {email}</p>
                <Outlet />
            </div>
        </div>
    );
}
